import BeatLoader from 'components/animations/Loaders/BeatLoader';
import { SIGNUP_ROUTE } from 'consts/routes/urls';
import useAuth from 'context/Auth';
import { useLandaRouter } from 'hooks/logics/useLandaRouter';
import React from 'react';
import classes from './index.module.scss';

const Protect = (Component: React.ComponentType) => {
  const WrapperComponent = (props: any) => {
    const { token, initialized } = useAuth();
    const { router } = useLandaRouter();

    const LoadingPage = (
      <div className={classes.loaderContainer}>
        <BeatLoader size={20} />
      </div>
    );

    if (!initialized) return LoadingPage;
    if (token) return <Component {...props} />;
    router.replace(SIGNUP_ROUTE);
  };
  return WrapperComponent;
};

export default Protect;
